import React from 'react';
import { Typography } from '@mui/material';
import { round } from 'lodash';

import styles from './WindStationCard.module.scss';

interface Props {
  windSpeedUnit: string;
  windGust: number;
  isOffline: boolean;
  noValue: string;
}

const WindStationCardGustsReading: React.FC<Props> = ({
  windSpeedUnit,
  windGust,
  isOffline,
  noValue,
}: Props) =>
  isOffline ? (
    <>
      {noValue}
      <Typography variant="callout2" className={styles.windSpeedUnit} component="span">
        {windSpeedUnit}
      </Typography>
    </>
  ) : (
    <>
      {round(windGust)}
      <Typography variant="callout2" className={styles.windSpeedUnit} component="span">
        {windSpeedUnit}
      </Typography>{' '}
      gust
    </>
  );

export default WindStationCardGustsReading;
